import { COMPANY_TYPES } from "../modules/registration/components/Company.utils";

export function mapResponseToCompanySearch(response, selectedItem) {
	return response?.items.map((company, index) => {
		const isSoleTrader = company.company_type === COMPANY_TYPES.SOLE_TRADER;

		return {
			key: company.name,
			value: isSoleTrader
				? company?.lookup_id
				: company?.national_identifier?.id,
			itemIndex: index,
			lookupId: company?.lookup_id,
			companyType: company?.company_type,
			isSelected: isSoleTrader
				? selectedItem === company.name
				: selectedItem === company?.national_identifier?.id ||
					selectedItem === company.name ||
					(!selectedItem && index === 0),
			isActive: isSoleTrader
				? selectedItem === company.name
				: selectedItem === company?.national_identifier?.id ||
					selectedItem === company.name ||
					(!selectedItem && index === 0),
		};
	});
}
